import React, { useEffect } from 'react'
import { useRefreshState } from '../../hooks/useRefreshState';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { applicationContextRoot } from '../../../constants/constants';
import loadingSvg from '../../../assets/GIF/loading.gif';

export default function LoadingPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useRefreshState();
  const { homeLink } = useSelector(state => state.role);

  useEffect(() => {
    console.log(isAuthenticated);
    // alert("isAuthenticated"+ isAuthenticated);
    // alert("isLoading"+ isLoading);
    //debugger;
    if (!isLoading) {
      if (isAuthenticated) {
        if(homeLink.startsWith("redirect:")){
          var redirectToUrl = homeLink.split(":")[1];
          navigate(applicationContextRoot + redirectToUrl);
        }else{
          navigate(applicationContextRoot + "/home");
        }
      } else {
        if(homeLink && homeLink.startsWith("redirect:")){
          var redirectToUrl = homeLink.split(":")[1];
          navigate(applicationContextRoot + redirectToUrl);
        }else{
          navigate(applicationContextRoot + "/login");
        }
      }
    }

    checkAuthentication();
  }, [isLoading]);

  function checkAuthentication() {

  }

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <img src={loadingSvg} alt="Loading..." />
    </div>
  )
}
